import { Loader } from "@/components/Loading";
import { Text } from "@/components/Typography";
import { Dialog } from "@/components/ui/dialog";
import { ApprovalTaskDetailDialogContent } from "@/features/boe-task/components/ApprovalTaskDetail/ApprovalTaskDetailDialogContent";
import { useTranslation } from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@tanstack/react-router";
import { useApprovalActions } from "./-hooks/useApprovalActions";
import { useDetailDialog } from "./-hooks/useDetailDialog";
import { useApprovalTaskDetailQuery } from "./-query/useApprovalTaskDetailQuery";
import { mapApprovalFlowToApprovers } from "./-utils/approvalFlowMapper";

export const Route = createFileRoute("/_staff/cockpit/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = useParams({ from: "/_staff/cockpit/$id/" });
  const { data, isLoading, error } = useApprovalTaskDetailQuery(id);
  const { approve, reject } = useApprovalActions();
  const { open, setOpen } = useDetailDialog();
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.cockpit.detail",
  });

  // ローディング中
  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  // エラー
  if (error || !data) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Text variant="p" className="text-red-600">
          {t("error")}
        </Text>
      </div>
    );
  }

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <ApprovalTaskDetailDialogContent
          taskStatus={data.taskStatus}
          taskType={data.taskType}
          taskName={data.taskName}
          taskTarget={data.taskTarget}
          targetSubordinate={data.targetSubordinate}
          description={data.description}
          progress={data.progress}
          dueDate={data.dueDate}
          assignee={{
            name: data.applicant.name,
          }}
          approvers={mapApprovalFlowToApprovers(
            data.approvalFlow,
            data.currentApprovalStage.order,
          )}
          onApprove={async () => {
            await approve(id);
            setOpen(false);
          }}
          onReject={async () => {
            await reject(id);
            setOpen(false);
          }}
          onReturn={() => {
            console.log("戻る");
            setOpen(false);
          }}
        />
      </Dialog>
    </>
  );
}
